import React, { useEffect, useState } from 'react';
import { makeStyles, Modal, IconButton } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SettingsIcon from '@material-ui/icons/Settings';
import Paper from '@material-ui/core/Paper';
import Input from "@material-ui/core/Input";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: 650,
    backdropFilter: "blur(3px)",
  },
}));

const ModalEditStats = ({ valueState, setState, onlyNumeric = false }) => {
  const classes = useStyles();

  const [modalStyle] = useState(getModalStyle);

  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState(<h1>Loading...</h1>)

  useEffect(() => {
    setRows(rowsHandler(valueState))
  }, [valueState])


  const handleOpen = () => {
    setOpen(true);
    // setRows(rowsHandler(valueState))
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeRow = (e, field) => {
    let fieldValue = e.target.value
    let nextValue = fieldValue
    if (!isNaN(fieldValue)) {
      nextValue = parseInt(fieldValue)
    } else {
      if (onlyNumeric) {
        console.log(fieldValue)
        return
      }
    }
    setState({ ...valueState, [field]: nextValue })
  }

  const rowsHandler = (newState) => (
    Object.keys(newState).map((value) => (
      <TableRow key={value}>
        <TableCell component="th" scope="row">
          {value}
        </TableCell>
        <TableCell align="right">
          <Input
            defaultValue={newState[value]}
            inputProps={{ 'aria-label': 'description' }}
            type={onlyNumeric ? "number" : ""}
            onChange={(e) => { onChangeRow(e, value) }} />
        </TableCell>
      </TableRow>
    ))
  )


  const modalBody = (
    <TableContainer className={classes.paper} style={modalStyle} component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Chave</TableCell>
            <TableCell align="right">Valor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows}
        </TableBody>
      </Table>
    </TableContainer>
  )
  return (
    <React.Fragment>
      <IconButton aria-label="delete" size="small" onClick={handleOpen}>
        <SettingsIcon fontSize="inherit" />
      </IconButton>
      <Modal
        open={open}
        onClose={handleClose}
      >
        {modalBody}
      </Modal>
    </React.Fragment>
  );
}
export default ModalEditStats